import { render, staticRenderFns } from "./TextBlockQuestion.vue?vue&type=template&id=fe862892&scoped=true&"
import script from "./TextBlockQuestion.vue?vue&type=script&lang=ts&"
export * from "./TextBlockQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe862892",
  null
  
)

export default component.exports